// Date helpers. Calendar-day values travel as 'YYYY-MM-DD' (DATEONLY) and must
// NOT pass through `new Date()` for display — that parses as UTC midnight and
// shifts a day in negative-offset zones (the v1 "día anterior" bug). Format
// straight from the string. See decisions/0004.

export function formatDateOnly(value) {
    if (!value) return '';
    const [y, m, d] = String(value).slice(0, 10).split('-');
    if (!y || !m || !d) return value;
    return `${d}/${m}/${y}`;
}
